 <template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0604'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>{{ growthModelName }} - 肥料</h3>
          </div>
          <div class="table-title-btn">
            <el-button type="primary" class="adduser" @click="handleAdd">添加</el-button>
            <el-button type="primary" class="adduser" @click="handleImport">导入</el-button>
            <el-button type="primary" class="adduser" @click="handleExport">导出</el-button>
            <el-button type="primary" class="adduser" @click="handleReturn">返回作物肥料模型</el-button>
          </div>
        </div>
        <!-- <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form> -->
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <!-- <el-table-column type="index" width="50">
            </el-table-column> -->
            <el-table-column align="center" label="排序号">
              <template slot-scope="scope">
                <p>{{ scope.row.orderNum }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="分组名称">
              <template slot-scope="scope">
                <p>{{ scope.row.groupName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="肥料名称">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="数量">
              <template slot-scope="scope">
                <p>{{ scope.row.num }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="单位">
              <template slot-scope="scope">
                <p>{{scope.row.unit}}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>

                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="排序号：" prop="orderNum">
                  <el-input v-model="ruleForm.orderNum" placeholder="请输入排序号" clearable maxlength="50" show-word-limit></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="分组名称：" prop="groupName">
                  <el-input v-model="ruleForm.groupName" placeholder="请输入分组名称" clearable maxlength="50" show-word-limit></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="肥料名称：" prop="name">
                  <el-input v-model="ruleForm.name" placeholder="请输入肥料名称" clearable maxlength="50" show-word-limit></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="数量：" prop="num">
                  <el-input v-model="ruleForm.num" placeholder="请输入数量" clearable maxlength="50" show-word-limit></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="单位：" prop="unit">
                  <el-input v-model="ruleForm.unit" placeholder="请输入单位" clearable maxlength="50" show-word-limit></el-input>
                </el-form-item>
              </el-col>

            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <el-dialog title="导入模板" :visible.sync="importDialog" width="500px" :before-close="handleCloseImport">
        <div class="equipmentcenter-opption-box">
          <el-form ref="importForm" label-width="0px">
            <el-form-item label="" style="width: 100%">
              <el-upload class="upload-demo" :action="$serverUrl + '/pc/growthModelFertilizer/importGrowthModelFertilizerList'" :data="{ modelFertilizerId: modelFertilizerId }" :headers="headers" name="file" :before-upload="handleChange" :on-success="handleAvatarSuccess" :limit="1" :file-list="importFileList">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传excel（.xls和.xlsx）文件
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件表单字段
        pageNum: 1,
        pageSize: 10,
        id: "",
      },
      headers: {
        // 请求头
        AUTHORIZATION: sessionStorage.getItem('TOKEN')
      },
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 表格加载中是否显示
      ruleForm: {
        // 添加编辑表单字段
        id: "",
        modelFertilizerId: "",
        name: "",
        num: "",
        unit: "",
        orderNum: '',
        groupName: '',
      },
      rules: {
        // 添加编辑表单规则
        name: [
          {
            required: true,
            message: "请输入肥料名称",
            trigger: "blur",
          },
        ],
        num: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: "请输入单位",
            trigger: "blur",
          },
        ],
        orderNum: [
          {
            required: true,
            message: "请输入单位",
            trigger: "blur",
          },
        ],
        groupName: [
          {
            required: true,
            message: "请输入单位",
            trigger: "blur",
          },
        ],
      },
      modelFertilizerId: "", // 模型ID
      growthModelName: "", // 模型名称
      addEditTitle: "添加肥料", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      importDialog: false
    };
  },
  created() {
    this.searchForm.id = this.$route.query.modelFertilizerId;
    this.ruleForm.modelFertilizerId = this.$route.query.modelFertilizerId;
    this.modelFertilizerId = this.$route.query.modelFertilizerId;
    this.growthModelName = this.$route.query.growthModelName;

    // 查询
    this.getList();
  },
  methods: {
    // 导出生长模型
    handleExport() {
      this.$api.growthModel.exportGrowthModelFertilizerList({ id: this.modelFertilizerId }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          window.location.href = res.data
        }
      })
    },
    // 导入
    handleImport() {
      this.$confirm('导入会替换原肥料模型，是否继续导入？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.importDialog = true
        })
        .catch(() => {
          this.$message.info('已取消导入')
        })
    },
    // 关闭导入弹窗
    handleCloseImport() {
      this.importDialog = false
      this.getGrowthModelData()
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.msg
        })
        // 重新获取生长模型数据
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 上传Excel
    handleChange(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式！',
          type: 'warning'
        })
      }
      return extension || extension2
    },
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        id: this.modelFertilizerId,
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.growthModel
        .getGrowthFertilizerList(this.searchForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          }
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.growthModel.delGrowthFertilizer(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑授权用户";
      this.ruleForm.modelFertilizerId = this.modelFertilizerId;
      this.getGrowthFertilizer(row.id)
    },
    getGrowthFertilizer(id) {
      this.$api.growthModel.getGrowthFertilizer({ id: id }).then(res => {
        if (res.code == 200) {
          this.ruleForm = res.data
        }
      })
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加授权用户";
      this.ruleForm.id = "";
      this.ruleForm.modelFertilizerId = this.modelFertilizerId;
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel
            .saveGrowthFertilizer(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.handleCancel();
                this.handleSearch();
              }
            });
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModel`,
        query: {
          currentShow: "three",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
  border-top: 1px solid #ededed;
  margin-top: 1px;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }
}
</style>